export default {
    greeting: {
        title: '안녕하세요!',
        description: '매일국어T가 선생님의 하루를 함께합니다.',
    },
    form: {
        id: '아이디',
        idPlaceholder: '아이디를 입력해주세요.',
        password: '비밀번호',
        passwordPlaceholder: '비밀번호를 입력해주세요.',
        errorId: '아이디를 입력해주세요.',
        errorPassword: '비밀번호를 입력해주세요.',
    },
    button: {
        login: '로그인',
    },
    modal: {
        title: '로그인 실패',
    },
};
